import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/pages/auth/services/auth.service';
import { NotifierService } from 'src/app/services/notifier.service';
import { resolve } from 'q';
import { emit } from 'cluster';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  toggleForm: boolean = true;
  email: string;
  otp: string;
  disablePasscode: boolean = false;
  forgotPasswordEmail: string;
  loginFormGroup: FormGroup;
  hidePassword = true;
  disableOnCaptcha=true;
  passcodeArray: any = [];
  saltValue = [];
  image: any;
  btnGetPasscode: boolean = false;
  disableSubmitBtn: boolean = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private notifierService: NotifierService,
    private errorhandlerService: ErrorHandlerService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.loginFormGroup = this.createLoginForm();
    let tokenValue = '';
    if (this.router.url.includes('email')) {
      let temp = this.router.url;
      tokenValue = temp.slice(temp.lastIndexOf('=') + 1);
      let token = {
        accessToken: tokenValue
      };
      this.getEmailFromToken(token);
    }
    this.getSaltAndCapcha();

  }

  public createLoginForm(): FormGroup {
    return this.fb.group({
      email: ["", [Validators.required]],
      otp: ["", [Validators.required]],
      captcha: ['', [Validators.required]]
    });
  }

  changeForm() {
    if (this.toggleForm)
      this.toggleForm = false;
    else
      this.toggleForm = true;
  }

  async login() {
    localStorage.setItem('token', 'token');
    this.router.navigate(['/dashboard']);
  }

  async forgotPassword(value: any) {
    console.log(value);
  }

  OnBtnClicked() {
    this.setCustomerPasscode();
  }

  OnInputData(event: Event) {
    this.email = (<HTMLInputElement>event.target).value;
  }

  disablePasscodeBtn() {
    this.disablePasscode = true;
    setTimeout(() => {
      this.disablePasscode = false;
    }, 30000);

  }

  onLoginBtnClicked() {
    this.loginUser();
  }

  setCustomerPasscode() {
    this.spinner.show();
    this.disablePasscodeBtn();
    this.email = this.loginFormGroup.controls.email.value;
    this.authService.setCustomerPasscode(this.email).subscribe((responce) => {
      this.spinner.hide();
      if (responce[0].IsValid == 1) {
        this.notifierService.successMessageHandler("Passcode has been sent to registered email");
      }
      else {
        this.notifierService.failedMessageHandler("This email is not registered");
      }
    }, error => {
      this.spinner.hide();
      this.notifierService.showServerError(error);
    });
  }

  loginUser() {
    if (this.loginFormGroup.value.captcha !== this.saltValue[2]) {
      this.notifierService.failedMessageHandler("Invalid captcha");
      return this.getSaltAndCapcha();
    }
    this.spinner.show();
    const data = this.loginFormGroup.getRawValue();
    data.sessionId=this.saltValue[0];
    this.authService.loginUser(data).subscribe((responce: any) => {
      this.spinner.hide();
      if (responce.accessToken) {
        localStorage.setItem('token', responce.accessToken);
        localStorage.setItem('email', this.email);
        this.router.navigate(['/tasks']);
      }
      else
        this.notifierService.failedMessageHandler("Invalid email or password");
    }, error => {
      this.spinner.hide();
      this.loginFormGroup.reset();
      this.getSaltAndCapcha();
      this.notifierService.showServerError(error.error);
      //this.errorhandlerService.handleError(error);
    });
  }

  onPasswordText(event: Event) {
    this.otp = (<HTMLInputElement>event.target).value;
  }

  getEmailFromToken(token) {
    this.authService.getEmailFromToken(token).subscribe((response) => {
      if (response) {
        this.loginFormGroup.controls.email.setValue(response);
        this.btnGetPasscode = true;
      } else {
        this.notifierService.failedMessageHandler('This url is invalid');
        this.loginFormGroup.disable();
        this.disableSubmitBtn = true;
        //Facing some issues from server for time being i did this change it should be reverted.
        // this.loginFormGroup.controls.email.setValue('venkatav@mailinator.com');
        // this.btnGetPasscode=true;
      }
    }, (error) => {
      //Facing some issues from server for time being i did this change it should be reverted.
      this.notifierService.failedMessageHandler("Invalid email please try again:" + error.error);
      // this.loginFormGroup.controls.email.setValue('venkatav@mailinator.com');
      // this.btnGetPasscode=true;
    });
  }

  getSaltAndCapcha() {
    this.spinner.show();
    this.authService.getSaltAndCapcha().subscribe(
      (response: any) => {
        //this.disableButton = true;
        this.saltValue = response;
        this.getCaptchaImage();
        this.spinner.hide();
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
        this.notifierService.showServerError(error.error);
      }
    );
  }

  getCaptchaImage() {
    const objectURL = 'data:image/png;base64,' + this.saltValue[3];
    this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }

  refreshCaptcha() {
    this.spinner.show();
    this.authService.getRefreshCaptcha(this.saltValue[0]).subscribe(
      (response: any) => {
        this.spinner.hide();
        this.saltValue[2] = response[0];
        this.saltValue[3] = response[1];
        //this.disableButton = true;
        this.getCaptchaImage();
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
        this.notifierService.showServerError(error.error);
      }
    );
  }

  onCaptchaEntered(value: any){
    // console.log(value,'value');
    if(value.length===6){
      this.disableOnCaptcha=false;
    }else{
      this.disableOnCaptcha=true;
    }
  }

}
